import { IMG, HOME_FAQS } from "@/data/site";
import { Reveal, SectionLabel } from "@/components/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export const HomeFAQ = () => (
  <section className="bg-brand-blue py-20 md:py-28" data-testid="home-faq">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <div className="mx-auto max-w-3xl text-center">
        <Reveal>
          <div className="flex justify-center"><SectionLabel dark>Common Questions</SectionLabel></div>
          <h2 className="mt-5 font-display text-3xl md:text-5xl font-light tracking-tight text-white text-balance">
            About <span className="font-extrabold">electrical, air conditioning</span> &amp; heat pump installation
          </h2>
        </Reveal>
      </div>

      <div className="mt-14 grid gap-10 lg:grid-cols-[38%_1fr] lg:gap-12 lg:items-start">
        <Reveal>
          <div className="relative overflow-hidden rounded-3xl border-4 border-[#1F6FB2]/30">
            <img src={IMG.reclaim} alt="Completed Access outdoor installation on a residential property" loading="lazy" className="h-full w-full object-cover" />
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible defaultValue="faq-0" className="space-y-4" data-testid="home-faq-accordion">
            {HOME_FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="overflow-hidden rounded-xl border-0 bg-white shadow-sm data-[state=open]:shadow-md"
              >
                <AccordionTrigger className="px-6 py-5 text-left font-display text-base md:text-lg font-semibold uppercase tracking-tight text-[#102A43] hover:no-underline [&>svg]:h-5 [&>svg]:w-5 [&>svg]:text-[#0B4F8A] [&[data-state=open]]:text-[#0B4F8A]">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="px-6 pb-6 text-[15px] leading-relaxed text-[#486581]">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </div>
  </section>
);
